import React, { useState } from 'react';
import Modal from 'react-modal';
import logo from './assets/perfil-2.jpeg';
import tiktokLogo from './assets/tik.PNG';
import instaLogo from './assets/insta.PNG';
import './App.css';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

function App() {
  const [modalIsOpen, setIsOpen] = useState(false)
  const [privateLink, setPrivateLink] = useState('')
  const onModalIsopen = (link) => {
    setIsOpen(true)
    setPrivateLink(link)
  }
  return (
    <div className="App">
      <div className='container'>
        <div>
          <h1>Fany Dely</h1>
        </div>
        <div className='photoContainer'>
          <img className='photo' alt='perfil' src={logo} />
        </div>
        <div>
          <p>😘😍 Hey.!!! sígueme en mis redes sociales ❤️‍🔥 Subo contenido que te gustara🤤</p>
        </div>
        <div className='linksContainer'>
          {/* <div className='linkItem' onClick={()=> window.location.href = 'https://twitter.com/FanyDely28' }> */}
          <div className='linkItem' onClick={() => onModalIsopen('https://twitter.com/FanyDely28')  }>
            <div className='socialImageContainer'>
              <img className='socialImage' alt='tw' src='https://i0.wp.com/hipertextual.com/wp-content/uploads/2012/06/twitter-bird-white-on-blue.jpg?fit=300%2C300&ssl=1' />
            </div>
            <div className='socialTextContainer'>
              <p className='socialText'>Twitter</p>
            </div>
          </div>
          <div className='linkItem' onClick={()=> window.location.href = 'https://www.tiktok.com/@fan_dely02?_t=8U9xp33TdY6&_r=1' }>
            <div className='socialImageContainer'>
              <img className='socialImage' alt='tik' src={tiktokLogo} />
            </div>
            <div className='socialTextContainer'>
              <p className='socialText'>TikTok de respaldo</p>
            </div>
          </div>
          <div className='linkItem' onClick={()=> window.location.href = 'https://www.instagram.com/daily.dely3/' }>
            <div className='socialImageContainer'>
              <img className='socialImage' alt='tik' src={instaLogo} />
            </div>
            <div className='socialTextContainer'>
              <p className='socialText'>Instagram</p>
            </div>
          </div>
          <div className='linkItem' onClick={() => onModalIsopen('https://t.me/+qgAkSeSeTJNjMDJh')}>
            <div className='socialImageContainer'>
              <img className='socialImage' alt='tik' src='https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Telegram_logo.svg/480px-Telegram_logo.svg.png' />
            </div>
            <div className='socialTextContainer'>
              <p className='socialText'>Telegram</p>
            </div>
          </div>
          <div className='linkItem' onClick={()=> window.location.href = 'https://twitter.com/FanyDely28' }>
            <div className='socialImageContainer'>
              <img className='socialImage' alt='tik' src='https://assets.dryicons.com/uploads/icon/svg/8401/02dbf6c2-8309-4e89-8ff6-a7ea954b78c1.svg' />
            </div>
            <div className='socialTextContainer'>
              <p className='socialText'>WhatsApp</p>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h2>Contenido delicado</h2>
        <p>Este link puede tener contenido no apropiado para todas las audiencias.</p>
        <button onClick={() => setIsOpen(false)}>Cerrar</button>
        <button onClick={() =>window.location.href = privateLink}>Abrir link</button>
      </Modal>
    </div>
    
  );
}

export default App;
